import styled, { css } from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

type ContainerProps = {
  clickable?: boolean
}

const shouldForwardProp = (prop: string) => !['clickable'].includes(prop)

const containerClickableCss = ({ clickable }: ContainerProps) =>
  clickable &&
  css`
    cursor: pointer;
  `

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<ContainerProps>`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: ${LANDING_CONTENT_WIDTH_PX}px;
  gap: ${themeGet('space.4')}px;

  svg {
    width: 25px;
    height: 25px;
    color: ${themeGet('colors.primary.main')};
  }

  ${containerClickableCss}
`
